export enum ServerEnv {
  Alpha = 'alpha',
  Dev = 'dev',
  Test = 'test',
  Sandbox = 'sandbox',
  Qa = 'qa',
  Beta = 'beta',
  Gw = 'gw', // closed beta 사내 업무용 환경
  Real = 'real',
}
